import { render } from "./SecretD.vue?vue&type=template&id=58815888&scoped=true"
import script from "./SecretD.vue?vue&type=script&lang=js"
export * from "./SecretD.vue?vue&type=script&lang=js"

import "./SecretD.vue?vue&type=style&index=0&id=58815888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58815888"]])

export default __exports__